/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosTrxScrollListRequest = {
    trxType?: AptosTrxScrollListRequest.trxType;
    size?: number;
    lastVal?: number;
    tp?: Array<'all' | 'genesis_transaction' | 'block_metadata_transaction' | 'user_transaction' | 'state_checkpoint_transaction' | 'validator_transaction' | 'pending_transaction' | 'block_epilogue_transaction'>;
    stime?: number;
    etime?: number;
    from?: string;
    to?: string;
    function?: string;
    samt?: number;
    eamt?: number;
    cid?: string;
};

export namespace AptosTrxScrollListRequest {

    export enum trxType {
        ALL = 'all',
        GENESIS_TRANSACTION = 'genesis_transaction',
        BLOCK_METADATA_TRANSACTION = 'block_metadata_transaction',
        USER_TRANSACTION = 'user_transaction',
        STATE_CHECKPOINT_TRANSACTION = 'state_checkpoint_transaction',
        VALIDATOR_TRANSACTION = 'validator_transaction',
        PENDING_TRANSACTION = 'pending_transaction',
        BLOCK_EPILOGUE_TRANSACTION = 'block_epilogue_transaction',
    }


}

